<template>
    <span
        v-html="svgIcon"
        :class="[$style['mds-icon'], sizeClass]"
        aria-hidden="true"
        :data-mds-version="version"
        :data-mds-icon-name="name"
    ></span>
</template>

<script>
    import icons from '../dist/mds-icons.json';
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsIcon',
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        props: {
            name: {
                type: String,
                docs: {
                    validation: 'Must be a valid icon name.',
                    description: 'Sets the icon.',
                },
            },
            title: {
                type: String,
                docs: {
                    validation: '—',
                    description: 'Sets the accessible title for the icon.',
                },
            },
            size: {
                type: String,
                default: 'medium',
                validator: value => ['small', 'medium'].indexOf(value) !== -1,
                docs: {
                    validation: 'One of: `small`, `medium`.',
                    description: 'Sets the size of the icon.',
                },
            },
        },
        customIcons: {},
        computed: {
            sizeClass() {
                return this.size === 'small' ? this.$style['mds-icon--small'] : '';
            },
            svgIcon() {
                return icons[this.name] || this.$options.customIcons[this.name];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './icon.scss';
</style>
